'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const PreviousIcon: TSVGIcon = createIcon({
  displayName: 'PreviousIcon',
  viewBox: '0 0 24 24',
  path: (
    <path d='m8.47 16.53-4-4-.013-.013-.007-.006-.006-.007-.007-.008-.005-.006-.008-.009-.008-.01-.015-.021-.011-.014-.01-.014-.01-.015v-.006l-.009-.009v-.015l-.011-.009v-.006l-.013-.012a.751.751 0 0 1 .148-.9L8.47 7.47a.75.75 0 0 1 1.06 1.061L6.811 11.25H19a.75.75 0 0 1 0 1.5H6.811l2.719 2.72a.75.75 0 1 1-1.06 1.06Z' />
  ),
});
